// Define a constant for the UPDATE_TEXT action type
export const UPDATE_TEXT = "UPDATE_TEXT";

/**
 * Action creator function for updating the text.
 *
 * @param {Object} data - The data containing the updated text.
 * @param {string} data.id - The identifier for the text item to update.
 * @param {string} data.text - The new text value.
 *
 * @returns {Object} - The action object to dispatch.
 * @returns {string} .type - The action type (UPDATE_TEXT).
 * @returns {Object} .payload - The data payload with the updated text.
 */
export const updateText = (data) => {
  return {
    type: UPDATE_TEXT,
    payload: data,
  };
};
